import common_butterfly from './img/bug/common_butterfly.png';
import yellow_butterfly from './img/bug/yellow_butterfly.png';
import tiger_butterfly from './img/bug/tiger_butterfly.png';
import peacock_butterfly from './img/bug/peacock_butterfly.png';
import common_bluebottle from './img/bug/common_bluebottle.png';
import paper_kite_butterfly from './img/bug/paper_kite_butterfly.png';
import great_purple_emperor from './img/bug/great_purple_emperor.png';
import monarch_butterfly from './img/bug/monarch_butterfly.png';
import emperor_butterfly from './img/bug/emperor_butterfly.png';
import agrias_butterfly from './img/bug/agrias_butterfly.png';
import rajah_brookes_birdwing from './img/bug/rajah_brookes_birdwing.png';
import queen_alexandras_birdwing from './img/bug/queen_alexandras_birdwing.png';
import moth from './img/bug/moth.png';
import atlas_moth from './img/bug/atlas_moth.png';
import madagascan_sunset_moth from './img/bug/madagascan_sunset_moth.png';
import long_locust from './img/bug/long_locust.png';
import migratory_locust from './img/bug/migratory_locust.png';
import rice_grasshopper from './img/bug/rice_grasshopper.png';
import grasshopper from './img/bug/grasshopper.png';
import cricket from './img/bug/cricket.png';
import bell_cricket from './img/bug/bell_cricket.png';
import mantis from './img/bug/mantis.png';
import orchid_mantis from './img/bug/orchid_mantis.png';
import honeybee from './img/bug/honeybee.png';
import wasp from './img/bug/wasp.png';
import brown_cicada from './img/bug/brown_cicada.png';
import robust_cicada from './img/bug/robust_cicada.png';
import giant_cicada from './img/bug/giant_cicada.png';
import walker_cicada from './img/bug/walker_cicada.png';
import evening_cicada from './img/bug/evening_cicada.png';
import cicada_shell from './img/bug/cicada_shell.png';
import red_dragonfly from './img/bug/red_dragonfly.png';
import darner_dragonfly from './img/bug/darner_dragonfly.png';
import banded_dragonfly from './img/bug/banded_dragonfly.png';
import damselfly from './img/bug/damselfly.png';
import firefly from './img/bug/firefly.png';
import mole_cricket from './img/bug/mole_cricket.png';
import pondskater from './img/bug/pondskater.png';
import diving_beetle from './img/bug/diving_beetle.png';
import giant_water_bug from './img/bug/giant_water_bug.png';
import stinkbug from './img/bug/stinkbug.png';
import man_faced_stink_bug from './img/bug/man-faced_stink_bug.png';
import ladybug from './img/bug/ladybug.png';
import tiger_beetle from './img/bug/tiger_beetle.png';
import jewel_beetle from './img/bug/jewel_beetle.png';
import violin_beetle from './img/bug/violin_beetle.png';
import citrus_long_horned_beetle from './img/bug/citrus_long-horned_beetle.png';
import rosalia_batesi_beetle from './img/bug/rosalia_batesi_beetle.png';
import blue_weevil_beetle from './img/bug/blue_weevil_beetle.png';
import dung_beetle from './img/bug/dung_beetle.png';
import earth_boring_dung_beetle from './img/bug/earth-boring_dung_beetle.png';
import scarab_beetle from './img/bug/scarab_beetle.png';
import drone_beetle from './img/bug/drone_beetle.png';
import goliath_beetle from './img/bug/goliath_beetle.png';
import saw_stag from './img/bug/saw_stag.png';
import miyama_stag from './img/bug/miyama_stag.png';
import giant_stag from './img/bug/giant_stag.png';
import rainbow_stag from './img/bug/rainbow_stag.png';
import cyclommatus_stag from './img/bug/cyclommatus_stag.png';
import golden_stag from './img/bug/golden_stag.png';
import giraffe_stag from './img/bug/giraffe_stag.png';
import horned_dynastid from './img/bug/horned_dynastid.png';
import horned_atlas from './img/bug/horned_atlas.png';
import horned_elephant from './img/bug/horned_elephant.png';
import horned_hercules from './img/bug/horned_hercules.png';
import walking_stick from './img/bug/walking_stick.png';
import walking_leaf from './img/bug/walking_leaf.png';
import bagworm from './img/bug/bagworm.png';
import ant from './img/bug/ant.png';
import hermit_crab from './img/bug/hermit_crab.png';
import wharf_roach from './img/bug/wharf_roach.png';
import fly from './img/bug/fly.png';
import mosquito from './img/bug/mosquito.png';
import flea from './img/bug/flea.png';
import snail from './img/bug/snail.png';
import pill_bug from './img/bug/pill_bug.png';
import centipede from './img/bug/centipede.png';
import spider from './img/bug/spider.png';
import tarantula from './img/bug/tarantula.png';
import scorpion from './img/bug/scorpion.png';


export const bugData = [
  { name: "Common Butterfly", image: common_butterfly },
  { name: "Yellow Butterfly", image: yellow_butterfly },
  { name: "Tiger Butterfly", image: tiger_butterfly },
  { name: "Peacock Butterfly", image: peacock_butterfly },
  { name: "Common Bluebottle", image: common_bluebottle },
  { name: "Paper Kite Butterfly", image: paper_kite_butterfly },
  { name: "Great Purple Emperor", image: great_purple_emperor },
  { name: "Monarch Butterfly", image: monarch_butterfly },
  { name: "Emperor Butterfly", image: emperor_butterfly },
  { name: "Agrias Butterfly", image: agrias_butterfly },
  { name: "Rajah Brookes Birdwing", image: rajah_brookes_birdwing },
  { name: "Queen Alexandras Birdwing", image: queen_alexandras_birdwing },
  { name: "Moth", image: moth },
  { name: "Atlas Moth", image: atlas_moth },
  { name: "Madagascan Sunset Moth", image: madagascan_sunset_moth },
  { name: "Long Locust", image: long_locust },
  { name: "Migratory Locust", image: migratory_locust },
  { name: "Rice Grasshopper", image: rice_grasshopper },
  { name: "Grasshopper", image: grasshopper },
  { name: "Cricket", image: cricket },
  { name: "Bell Cricket", image: bell_cricket },
  { name: "Mantis", image: mantis },
  { name: "Orchid Mantis", image: orchid_mantis },
  { name: "Honeybee", image: honeybee },
  { name: "Wasp", image: wasp },
  { name: "Brown Cicada", image: brown_cicada },
  { name: "Robust Cicada", image: robust_cicada },
  { name: "Giant Cicada", image: giant_cicada },
  { name: "Walker Cicada", image: walker_cicada },
  { name: "Evening Cicada", image: evening_cicada },
  { name: "Cicada Shell", image: cicada_shell },
  { name: "Red Dragonfly", image: red_dragonfly },
  { name: "Darner Dragonfly", image: darner_dragonfly },
  { name: "Banded Dragonfly", image: banded_dragonfly },
  { name: "Damselfly", image: damselfly },
  { name: "Firefly", image: firefly },
  { name: "Mole Cricket", image: mole_cricket },
  { name: "Pondskater", image: pondskater },
  { name: "Diving Beetle", image: diving_beetle },
  { name: "Giant Water Bug", image: giant_water_bug },
  { name: "Stinkbug", image: stinkbug },
  { name: "Man-Faced Stink Bug", image: man_faced_stink_bug },
  { name: "Ladybug", image: ladybug },
  { name: "Tiger Beetle", image: tiger_beetle },
  { name: "Jewel Beetle", image: jewel_beetle },
  { name: "Violin Beetle", image: violin_beetle },
  { name: "Citrus Long-Horned Beetle", image: citrus_long_horned_beetle },
  { name: "Rosalia Batesi Beetle", image: rosalia_batesi_beetle },
  { name: "Blue Weevil Beetle", image: blue_weevil_beetle },
  { name: "Dung Beetle", image: dung_beetle },
  { name: "Earth-Boring Dung Beetle", image: earth_boring_dung_beetle },
  { name: "Scarab Beetle", image: scarab_beetle },
  { name: "Drone Beetle", image: drone_beetle },
  { name: "Goliath Beetle", image: goliath_beetle },
  { name: "Saw Stag", image: saw_stag },
  { name: "Miyama Stag", image: miyama_stag },
  { name: "Giant Stag", image: giant_stag },
  { name: "Rainbow Stag", image: rainbow_stag },
  { name: "Cyclommatus Stag", image: cyclommatus_stag },
  { name: "Golden Stag", image: golden_stag },
  { name: "Giraffe Stag", image: giraffe_stag },
  { name: "Horned Dynastid", image: horned_dynastid },
  { name: "Horned Atlas", image: horned_atlas },
  { name: "Horned Elephant", image: horned_elephant },
  { name: "Horned Hercules", image: horned_hercules },
  { name: "Walking Stick", image: walking_stick },
  { name: "Walking Leaf", image: walking_leaf },
  { name: "Bagworm", image: bagworm },
  { name: "Ant", image: ant },
  { name: "Hermit Crab", image: hermit_crab },
  { name: "Wharf Roach", image: wharf_roach },
  { name: "Fly", image: fly },
  { name: "Mosquito", image: mosquito },
  { name: "Flea", image: flea },
  { name: "Snail", image: snail },
  { name: "Pill Bug", image: pill_bug },
  { name: "Centipede", image: centipede },
  { name: "Spider", image: spider },
  { name: "Tarantula", image: tarantula },
  { name: "Scorpion", image: scorpion },
];

export default bugData;